import { ApplicationLanguages } from "../../../../enum/common-enum";

export interface UILanguage {
    id: number;
    name: string;
    locale: string;
    languageCode: string;
    regionCode: string;
    flagCode: string;
  }

  // Define the uiLanguages array within the class
  export class UILanguage {
    static uiLanguages = [
      { id: 1, name: 'English', locale: ApplicationLanguages?.English, languageCode: 'en', regionCode: 'US', flagCode: 'us' },
      { id: 2, name: 'Español', locale: ApplicationLanguages?.Spanish, languageCode: 'es', regionCode: 'ES', flagCode: 'mx' }
    ];
  
    static getLanguages() {
      return this.uiLanguages;
    }
  }